<template lang="pug">
  section(v-if="vertical")
    b-field(horizontal label="取次コード" custom-class="label-box")
      b-autocomplete(
        data-vv-as="取次コード"
        :name="input_name"
        size="is-small"
        v-model="newInternalAgencyCodeValue"
        :disabled="disabled || loading"
        :loading="loading"
        :ref="input_name"
        :data="filteredAgencyObj"
        field="name"
        open-on-focus
      )
      p {{ agencyCodeName }}
    b-field(horizontal label="取次書店コード" custom-class="label-box")
      b-autocomplete(
        :data-vv-name="input_name"
        data-vv-as="取次書店コード"
        size="is-small"
        v-model="newInternalAgencyShopCodeValue"
        :disabled="disabled || loading"
        :loading="loading"
        :data="filteredDataObjSlice"
        field="agency_shop_code"
        open-on-focus
      )
      p {{ newInternalAgencyShopName }}

  b-field(:type="{'is-danger': error(input_name, errors)}"
          :message="errorMessageFor(input_name, errors)" v-else)
    b-autocomplete(
      data-vv-as="帳合コード"
      :name="input_name"
      size="is-small"
      v-model="newInternalAgencyCodeValue"
      :disabled="disabled || loading"
      :loading="loading"
      :ref="input_name"
      :data="filteredAgencyObj"
      field="name"
      open-on-focus
    )

    b-autocomplete(
      :data-vv-name="input_name"
      data-vv-as="書店コード"
      size="is-small"
      v-model="newInternalAgencyShopCodeValue"
      :disabled="disabled || loading"
      :loading="loading"
      :data="filteredDataObjSlice"
      field="agency_shop_code"
      open-on-focus
    )
    | {{ agencyCodeName }}
    | {{ newInternalAgencyShopName }}

</template>

<script>
  import ErrorDisplayer from 'mixins/error_displayer'

  export default {
    name: 'agency-shop-code-input',
    mixins: [ErrorDisplayer],
    data() {
      return {
        current_final_book_shop_agencies: [],
        first_flag: true,
      }
    },
    props: {
      input_name: {
        type: String,
        required: true
      },
      agency_code: {
        type: String
      },
      agency_shop_code: {
        type: String
      },
      disabled: {
        type: Boolean,
        required: false
      },
      final_book_shop_agencies: {
        type: Array,
        required: true,
        default: []
      },
      agencies: {
        type: Array,
        required: true,
        default: []
      },
       errors: {
         required: false
       },
       vertical: {
         type: Boolean,
         required: false
       }
    },
    computed: {
      loading(){
        return 0 == this.final_book_shop_agencies.length
      },
      newInternalAgencyCodeValue: {
        get() {
          return this.agency_code
        },
        set(newVal) {
          var agencyCode = this.agencyCode(newVal)
          if (this.agency_code !== agencyCode) {
            this.$emit('update:agency_code', agencyCode)
            this.$nextTick(() => this.setCurrentFinalBookShopAgencies())
          }
        }
      },
      agencyCodeName() {
        var obj = this.agencies.filter((agency) => {
          return agency.code == this.newInternalAgencyCodeValue
        })
        if(obj.length == 1) {
          return obj[0].name
        } else {
          return ""
        }
      },
      filteredAgencyObj() {
        return this.agencies.filter((agency) => {
          return `${agency.code} ${agency.name}`.indexOf(this.newInternalAgencyCodeValue) >= 0
        })
      },
      newInternalAgencyShopCodeValue: {
        get() {
          return this.agency_shop_code
        },
        set(newVal) {
          if (this.agency_shop_code !== newVal) {
            this.$emit('update:agency_shop_code', newVal)
          }
        }
      },
      newInternalAgencyShopName() {
        var a = this.final_book_shop_agencies.filter((final_book_shop_agency) => {
          return final_book_shop_agency.agency_shop_code == this.newInternalAgencyShopCodeValue && final_book_shop_agency.agency_code == this.newInternalAgencyCodeValue
        })
        if(a.length > 0){
          return a[0].name
        }else{
          return ""
        }
      },
      filteredDataObjSlice() {
        return this.filteredDataObj.slice(0, 10)
      },
      filteredDataObj(){
        return this.current_final_book_shop_agencies.filter((final_book_shop_agency) => {
          return `${final_book_shop_agency.agency_shop_code}`.indexOf(this.newInternalAgencyShopCodeValue) === 0
        })
      }

    },
    watch: {
      final_book_shop_agencies(newVal, oldVal){
        if(newVal.length > 0 && oldVal.length == 0){
          this.setCurrentFinalBookShopAgencies()
        }
      }
    },
    methods: {
      setCurrentFinalBookShopAgencies(){
        if(this.newInternalAgencyCodeValue == null) {
          return
        }

        this.current_final_book_shop_agencies = []
        this.final_book_shop_agencies.filter((final_book_shop_agency) => {
          return (final_book_shop_agency.agency_code == this.newInternalAgencyCodeValue )
        }).forEach((final_book_shop_agency) => {
          this.current_final_book_shop_agencies.push(final_book_shop_agency)
        })
      },
      ensureDropDownVisibility(id) {
        let container = document.querySelector("#" + id)
          container.querySelector("div.autocomplete").style.overflow = "visible"
          container.querySelector("div.field").style.overflow = "visible"
          container.style.position = "fixed"
      },
      undoStyleChange(id) {
        let container = document.querySelector("#" + id)
          container.querySelector("div.autocomplete").style.overflow = "hidden"
          container.querySelector("div.field").style.overflow = "hidden"
          container.style.position = "relative"
      },
      agencyCode(value) {
        if(!value) return null

        var agencies = this.agencies.filter((agency) => {
          if(value.search(/^[0-9]+$/) >= 0)
            return agency.code === value
          return agency.name === value
        })
        if(agencies.length == 1) {
          return agencies[0].code
        } else {
          return value
        }
      }
    },
    created() {
    },
  }
</script>